import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    template: "",
    standalone: false
})
export class UIData {
    @Output()
    public requestHeaderHeight: EventEmitter<HeaderHeightRequest> = new EventEmitter();
}

export type HeaderHeightRequest = (height: number) => void;